import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { FormattedMessage } from 'react-intl';
import Collapsible from '../../../../components/collapsible/Collapsible';
import Clickable from '../../../../components/clickable/Clickable';
import FileSlider from '../../../../components/photoCarousel/FileSlider';
import Modal from '../../../../components/modal';
import CustomFieldDetail from '../../../../components/customFields/CustomFieldDetail';
import { renderInfoForType } from '../../../../utils/helpers';

import styles from '../../forms.module.scss';
import collapseSty from './Approvals.module.scss';


class StepInfoBox extends Component {
  state = {
    modal: false
  };

  openPhotoModal = (idx) => {
    this.setState({ modal: true, initialSlide: idx });
  }

  getStepFields = (steps = []) => steps.filter((field) => {
    const startsWithEx = field.id.startsWith('ex');
    const hasExposedId = !!field?.meta_data?.exposedId;
    return (!startsWithEx || !hasExposedId) && field?.disable_for_portal !== true;
  });

  render() {
    const { info, step, collpaseAll, form_entry_data, formApprovalProcess, collapsibleTitle, profile } = this.props;
    const { modal, initialSlide } = this.state;

    return (
      <Collapsible
        title={collapsibleTitle || step?.title || 'Approval'}
        styleClasses={`${collapseSty.collapsibleHeader}`}
        autoheight
        contentStyles={styles.contentStyles}
        openOnMount={collpaseAll}
        collapsibleHeight="0"
      >
        <div className={styles.stepInfo} style={{ borderTop: '1px solid #E6EAEE', marginTop: '0px' }}>
          <div className={styles.infoHalf}>
            <FormattedMessage id="workorder.detail.info.completed_by" defaultMessage="Completed by" />
            <p>{info?.logged_by?.fullname}</p>
          </div>
          <div className={styles.infoHalf}>
            <FormattedMessage id="workorder.detail.info.completed_on" defaultMessage="Completed on" />
            <p>{renderInfoForType({ type: 'datetime' }, info?.completed_date, null, null)}</p>
          </div>
          <div style={{ width: '100%' }}>
            <CustomFieldDetail
              data={info?.data || {}}
              version={{ schema: { fields: step?.fields || [] } }}
              fields={this.getStepFields(step?.fields) || []}
              form_entry_data={form_entry_data}
              formApprovalProcess={formApprovalProcess}
              profile={profile}
              mcgHeader
              showMultiColTitle
            />
          </div>
          <div className={styles.infoFull} style={{ border: 'none' }}>
            <FormattedMessage id="form.detail.info.description" defaultMessage="Remarks/Comments" />
            <p className={styles.preserveNewLines}>{info?.comment !== 'undefined' && info?.comment}</p>
          </div>
          {info?.attachments && Object.keys(info?.attachments).length > 0 && (
          <div className={styles.requestInfoField}>
            <span className={styles.title}>
              <FormattedMessage
                id="workorder.detail.request.photos"
                defaultMessage="Photos"
              />
            </span>
            {Object.keys(info.attachments).length > 0 && (
              <div className={styles.photos}>
                {info.attachments.map((e, idx) => (
                  <Clickable
                    key={e.id}
                    onClick={() => this.openPhotoModal(idx)}
                  >
                    {(e.type || e.content_type)?.includes('image') ? (
                      <img src={e.url} alt={e.id} />
                    ): (
                      <p>{e.name || e.file_name}</p>
                    )}
                  </Clickable>
                ))}
              </div>
            )}
          </div>
          )}
        </div>
        {info?.attachments?.length > 0 && (
          <Modal
            showIn={modal}
            onClose={() => this.setState({ modal: false })}
            contentStyles={{
              overflow: 'visible',
              background: '#E6EAEE',
              padding: '20px 40px'
            }}
          >
            <div>
              <FileSlider
                photos={info.attachments}
                initialSlide={initialSlide}
              />
            </div>
          </Modal>
        )}
      </Collapsible>
    );
  }
}

StepInfoBox.propTypes = {
  info: PropTypes.shape({}).isRequired,
  step: PropTypes.string.isRequired
};

export default StepInfoBox;
